import React from 'react';
import classNames from "classnames";
import PropTypes from 'prop-types';
import './ButtonShop.scss';

const ROOT_CLS = 'button-goml';
export const TYPE_DEFAULT = 'default';
export const TYPE_SECONDARY = 'big';
export const TYPE_FULL_WIDTH = 'full_width';

export default function ButtonShop(props) {
	const { size = TYPE_DEFAULT, text, className = '', onClick } = props;

	return (
		<div
			onClick={onClick}
			className={classNames([ROOT_CLS, `${ROOT_CLS}--${size}`, className])}>
			<span className={'text'}>{text}</span>
		</div>
	)
}

export const ButtonShopPropType = {
	text: PropTypes.string.isRequired,
	size: PropTypes.oneOf([
		TYPE_DEFAULT,
		TYPE_SECONDARY,
		TYPE_FULL_WIDTH,
	]),
	className: PropTypes.string,
	onClick: PropTypes.func,
}

ButtonShop.propTypes = ButtonShopPropType;
